<template>
    <div
        class="app"
        v-if="!appOptions.appEmpty"
        v-bind:class="{
            'app-header-fixed': appOptions.appHeaderFixed && !appOptions.appHeaderNone,
            'app-sidebar-fixed': appOptions.appSidebarFixed,
            'app-sidebar-minified': appOptions.appSidebarMinified,
            'app-content-full-height': appOptions.appContentFullHeight,
            'app-without-sidebar': appOptions.appSidebarNone,
            'app-with-end-sidebar': appOptions.appSidebarEnd,
            'app-with-two-sidebar': appOptions.appSidebarTwo,
            'app-with-wide-sidebar': appOptions.appSidebarWide,
            'app-with-light-sidebar': appOptions.appSidebarLight,
            'app-sidebar-mobile-toggled': appOptions.appSidebarMobileToggled,
            'app-sidebar-end-toggled': appOptions.appSidebarEndToggled,
            'app-sidebar-end-collapsed': !appOptions.appSidebarEndToggled,
            'app-sidebar-end-mobile-toggled': appOptions.appSidebarEndMobileToggled,
            'app-without-header': appOptions.appHeaderNone,
            'app-with-top-menu': appOptions.appTopMenu,
            'app-gradient-enabled': appOptions.appGradientEnabled,
            'has-scroll': appOptions.appBodyScrollTop,
        }"
    >
        <Header />
        <TopMenu v-if="appOptions.appTopMenu" />
        <Sidebar v-if="!appOptions.appSidebarNone" />
        <SidebarRight v-if="appOptions.appSidebarTwo" />
        <div id="content" class="app-content" v-bind:class="appOptions.appContentClass">
            <ErrorBoundary>
                <router-view></router-view>
            </ErrorBoundary>
            <vue-ins-progress-bar></vue-ins-progress-bar>
        </div>
        <notifications group="alerts-global" position="top right" :speed="500" :ignore-duplicates="true">
            <template slot="body" slot-scope="props">
                <div :class="['vue-notification', props.item.type]" @click="handleGlobalNotificationClick(props)">
                    <div v-if="props.item.title" class="notification-title" v-html="props.item.title"></div>
                    <div class="notification-content" v-html="props.item.text"></div>
                </div>
            </template>
        </notifications>
        <SidebarRight v-if="appOptions.appSidebarTwo" />
        <!-- <ThemePanel v-on:change-theme="handleChangeTheme" /> -->
        <ScrollTopBtn />
    </div>
    <div class="h-100" v-else>
        <router-view></router-view>
        <vue-ins-progress-bar></vue-ins-progress-bar>
    </div>
</template>

<script>
import Sidebar from './components/sidebar/Sidebar.vue'
import SidebarRight from './components/sidebar-right/SidebarRight.vue'
import Header from './components/header/Header.vue'
import TopMenu from './components/top-menu/TopMenu.vue'
// import ThemePanel from './components/theme-panel/ThemePanel.vue'
import ScrollTopBtn from './components/scroll-top-btn/ScrollTopBtn.vue'
import ErrorBoundary from './components/ErrorBoundary.vue'
import AppOptions from './config/AppOptions.vue'
import Common from './common/Common.vue'
import { db } from './firebaseInit.js'
import { deleteDoc, doc, onSnapshot } from 'firebase/firestore'
import moment from 'moment-timezone'
import alarmSoundUrl from './assets/sound/alarm.mp3'
import phoneRingtoneUrl from './assets/sound/phone-ringtone.wav'
import socket from './config/websocket.js'
import { clearPendingIncomingCall, peekPendingIncomingCall, setPendingIncomingCall } from './services/operatorCallBridge'

export default {
    name: 'app',
    components: {
        Sidebar,
        SidebarRight,
        Header,
        TopMenu,
        // ThemePanel,
        ScrollTopBtn,
        ErrorBoundary,
    },
    data() {
        return {
            appOptions: AppOptions,
            sosNotificationsUnsubscribes: [],
            sosNotificationSitesKey: '',
            operatorSocketHandlers: null,
            operatorSocketIdentityKey: '',
            operatorSocketHeartbeat: null,
            incomingCallNotificationRoomId: '',
            incomingCallRingtoneAudio: null,
        }
    },
    methods: {
        handleScroll: function () {
            AppOptions.appBodyScrollTop = window.scrollY
        },
        handleSetColor: function () {
            AppOptions.color = {
                componentColor: window.getComputedStyle(document.body).getPropertyValue('--app-component-color').trim(),
                componentBg: window.getComputedStyle(document.body).getPropertyValue('--app-component-bg').trim(),
                dark: window.getComputedStyle(document.body).getPropertyValue('--bs-dark').trim(),
                light: window.getComputedStyle(document.body).getPropertyValue('--bs-light').trim(),
                blue: window.getComputedStyle(document.body).getPropertyValue('--bs-blue').trim(),
                indigo: window.getComputedStyle(document.body).getPropertyValue('--bs-indigo').trim(),
                purple: window.getComputedStyle(document.body).getPropertyValue('--bs-purple').trim(),
                pink: window.getComputedStyle(document.body).getPropertyValue('--bs-pink').trim(),
                red: window.getComputedStyle(document.body).getPropertyValue('--bs-red').trim(),
                orange: window.getComputedStyle(document.body).getPropertyValue('--bs-orange').trim(),
                yellow: window.getComputedStyle(document.body).getPropertyValue('--bs-yellow').trim(),
                green: window.getComputedStyle(document.body).getPropertyValue('--bs-green').trim(),
                success: window.getComputedStyle(document.body).getPropertyValue('--bs-success').trim(),
                teal: window.getComputedStyle(document.body).getPropertyValue('--bs-teal').trim(),
                cyan: window.getComputedStyle(document.body).getPropertyValue('--bs-cyan').trim(),
                white: window.getComputedStyle(document.body).getPropertyValue('--bs-white').trim(),
                gray: window.getComputedStyle(document.body).getPropertyValue('--bs-gray').trim(),
                lime: window.getComputedStyle(document.body).getPropertyValue('--bs-lime').trim(),
                gray100: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-100').trim(),
                gray200: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-200').trim(),
                gray300: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-300').trim(),
                gray400: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-400').trim(),
                gray500: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-500').trim(),
                gray600: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-600').trim(),
                gray700: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-700').trim(),
                gray800: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-800').trim(),
                gray900: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-900').trim(),
                black: window.getComputedStyle(document.body).getPropertyValue('--bs-black').trim(),
                componentColorRgb: window.getComputedStyle(document.body).getPropertyValue('--app-component-color-rgb').trim(),
                componentBgRgb: window.getComputedStyle(document.body).getPropertyValue('--app-component-bg-rgb').trim(),
                darkRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-dark-rgb').trim(),
                lightRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-light-rgb').trim(),
                blueRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-blue-rgb').trim(),
                indigoRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-indigo-rgb').trim(),
                purpleRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-purple-rgb').trim(),
                pinkRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-pink-rgb').trim(),
                redRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-red-rgb').trim(),
                orangeRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-orange-rgb').trim(),
                yellowRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-yellow-rgb').trim(),
                greenRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-green-rgb').trim(),
                successRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-success-rgb').trim(),
                tealRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-teal-rgb').trim(),
                cyanRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-cyan-rgb').trim(),
                whiteRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-white-rgb').trim(),
                grayRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-rgb').trim(),
                limeRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-lime-rgb').trim(),
                gray100Rgb: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-100-rgb').trim(),
                gray200Rgb: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-200-rgb').trim(),
                gray300Rgb: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-300-rgb').trim(),
                gray400Rgb: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-400-rgb').trim(),
                gray500Rgb: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-500-rgb').trim(),
                gray600Rgb: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-600-rgb').trim(),
                gray700Rgb: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-700-rgb').trim(),
                gray800Rgb: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-800-rgb').trim(),
                gray900Rgb: window.getComputedStyle(document.body).getPropertyValue('--bs-gray-900-rgb').trim(),
                blackRgb: window.getComputedStyle(document.body).getPropertyValue('--bs-black-rgb').trim(),
            }
        },
        handleSetFont: function () {
            AppOptions.font = {
                family: window.getComputedStyle(document.body).getPropertyValue('--bs-body-font-family').trim(),
                size: window.getComputedStyle(document.body).getPropertyValue('--bs-body-font-size').trim(),
                weight: window.getComputedStyle(document.body).getPropertyValue('--bs-body-font-family').trim(),
            }
        },
        handleSound: function (value) {
            if (value === true) {
                document.body.classList.add('sound')
            } else {
                document.body.classList.remove('sound')
            }
        },
        handleSetDarkMode: function (value) {
            if (value === true) {
                document.body.classList.add('dark-mode')
            } else {
                document.body.classList.remove('dark-mode')
            }
            this.handleSetColor()
        },
        getSessionDarkMode: function () {
            return this.$session.get('user')?.darkMode === true
        },
        syncDarkModeFromSession: function () {
            const darkMode = this.getSessionDarkMode()
            AppOptions.appDarkMode = darkMode
            this.appOptions.appDarkMode = darkMode
            this.handleSetDarkMode(darkMode)
        },
        handleSetTheme: function (value) {
            var newTheme = 'theme-' + value
            for (var x = 0; x < document.body.classList.length; x++) {
                if (document.body.classList[x].indexOf('theme-') > -1 && document.body.classList[x] !== newTheme) {
                    document.body.classList.remove(document.body.classList[x])
                }
            }
            document.body.classList.add(newTheme)
        },
        handleChangeTheme: function () {
            this.handleSetTheme(AppOptions.appTheme)
            this.handleSetDarkMode(AppOptions.appDarkMode)
        },
        clearSosNotificationListeners: function () {
            this.sosNotificationsUnsubscribes.forEach(unsubscribe => unsubscribe())
            this.sosNotificationsUnsubscribes = []
            this.sosNotificationSitesKey = ''
        },
        getOperatorSites: function () {
            const user = this.$session.get('user')
            const isOperator = user?.companyUser?.subtype === 'OPERATOR'
            if (!isOperator) return []

            const sites = user?.siteGroup?.sites
            if (!Array.isArray(sites)) return []

            return [...new Set(sites.filter(Boolean))]
        },
        normalizeIdCandidate: function (value) {
            if (value === null || value === undefined) return ''

            if (typeof value === 'string' || typeof value === 'number') {
                const normalized = String(value).trim()
                return normalized || ''
            }

            if (typeof value === 'object') {
                return this.normalizeIdCandidate(value?._id || value?.id || value?.accountId || value?.companyId || value?.userId || '')
            }

            return ''
        },
        firstValidId: function (...candidates) {
            for (let index = 0; index < candidates.length; index += 1) {
                const resolved = this.normalizeIdCandidate(candidates[index])
                if (resolved) return resolved
            }
            return ''
        },
        decodeSessionTokenPayload: function () {
            const token = this.$session.get('token')
            if (!token || typeof token !== 'string') return null

            const tokenParts = token.split('.')
            if (tokenParts.length < 2) return null

            try {
                const base64Payload = tokenParts[1].replace(/-/g, '+').replace(/_/g, '/')
                const paddedPayload = base64Payload.padEnd(base64Payload.length + ((4 - (base64Payload.length % 4)) % 4), '=')
                return JSON.parse(window.atob(paddedPayload))
            } catch {
                return null
            }
        },
        isOperatorSessionActive: function () {
            const token = this.$session.get('token')
            const user = this.$session.get('user')
            const tokenPayload = this.decodeSessionTokenPayload()
            const subtype = String(user?.companyUser?.subtype || tokenPayload?.role || tokenPayload?.subtype || '')
                .trim()
                .toUpperCase()
            const userId = this.firstValidId(user?._id, user?.id, user?.userId, tokenPayload?.userId, tokenPayload?.sub, tokenPayload?._id)
            return Boolean(token && subtype === 'OPERATOR' && userId)
        },
        getOperatorSocketIdentity: function () {
            const user = this.$session.get('user') || {}
            const tokenPayload = this.decodeSessionTokenPayload()
            const userId = this.firstValidId(user?._id, user?.id, user?.userId, tokenPayload?.userId, tokenPayload?.sub, tokenPayload?._id)
            const accountId = this.firstValidId(
                user?.account,
                user?.accountId,
                user?.companyUser?.account,
                user?.companyUser?.accountId,
                user?.companyUser?.company?.account,
                user?.companyUser?.company?.accountId,
                user?.companyUser?.company,
                user?.company,
                tokenPayload?.account,
                tokenPayload?.accountId,
                tokenPayload?.company,
                tokenPayload?.companyId,
            )
            const displayName = [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim() || user?.fullName || user?.username || user?.email || 'Central'
            return {
                userId: userId ? String(userId) : '',
                accountId: accountId ? String(accountId) : '',
                role: String(user?.companyUser?.subtype || tokenPayload?.role || tokenPayload?.subtype || '')
                    .trim()
                    .toUpperCase(),
                displayName,
            }
        },
        normalizeIncomingCallPayload: function (payload = {}) {
            const fromLabel = payload?.fromLabel || payload?.fromDisplayName || payload?.from || 'Vigilante'
            return {
                roomId: payload?.roomId || '',
                from: payload?.from || '',
                fromLabel: String(fromLabel).trim() || 'Vigilante',
                fromClientType: payload?.fromClientType || '',
                fromRole: payload?.fromRole || '',
                callMode: payload?.callMode === 'SILENT_LISTEN' ? 'SILENT_LISTEN' : 'NORMAL',
            }
        },
        startIncomingCallRingtone: function () {
            try {
                if (!this.incomingCallRingtoneAudio) {
                    this.incomingCallRingtoneAudio = new Audio(phoneRingtoneUrl)
                    this.incomingCallRingtoneAudio.loop = true
                    this.incomingCallRingtoneAudio.preload = 'auto'
                }
                this.incomingCallRingtoneAudio.volume = 1
                this.incomingCallRingtoneAudio.currentTime = 0
                const playPromise = this.incomingCallRingtoneAudio.play()
                if (playPromise?.catch) {
                    playPromise.catch(() => {})
                }
            } catch {
                // ignore ringtone errors (autoplay policy, etc)
            }
        },
        stopIncomingCallRingtone: function () {
            try {
                if (!this.incomingCallRingtoneAudio) return
                this.incomingCallRingtoneAudio.pause()
                this.incomingCallRingtoneAudio.currentTime = 0
            } catch {
                // ignore ringtone errors
            }
        },
        isAlertportIncomingCall: function (incomingCall = {}) {
            const clientType = String(incomingCall?.fromClientType || '').toUpperCase()
            return clientType.includes('ALERTPORT')
        },
        resolveIncomingCallTargetRoute: function (incomingCall = {}) {
            return this.isAlertportIncomingCall(incomingCall) ? '/monitor/alert-occurrence' : '/monitor'
        },
        showIncomingCallNotification: function (incomingCall = {}) {
            const user = this.$session.get('user')
            const timezone = Common.resolveTimezoneId(user?.accountTimezone || user?.account?.timezone || 'America/Sao_Paulo')
            const date = moment.tz(timezone).format('DD/MM/YYYY - HH:mm:ss')
            const isAlertport = this.isAlertportIncomingCall(incomingCall)
            const defaultCaller = isAlertport ? 'Dispositivo AlertPort' : 'Vigilante'
            const caller = incomingCall?.fromLabel || defaultCaller
            const modeText = incomingCall?.callMode === 'SILENT_LISTEN' ? 'Escuta ativa solicitada' : 'Ligação recebida'
            const targetLabel = isAlertport ? 'Ocorrência de Alerta' : 'Monitoramento'

            this.$notify({
                group: 'alerts-global',
                type: 'warn',
                title: modeText,
                text: `${this.$t('str.date.subtitle')}: ${date}<br>${caller} está ligando. Clique para abrir no ${targetLabel}.`,
                duration: -1,
                data: {
                    callRoomId: incomingCall?.roomId || '',
                    callFrom: incomingCall?.from || '',
                    callFromLabel: caller,
                    callFromClientType: incomingCall?.fromClientType || '',
                    callTargetRoute: this.resolveIncomingCallTargetRoute(incomingCall),
                },
            })
        },
        navigateToMonitorFromIncomingCall: async function ({ roomId = '', from = '', fromLabel = '', targetRoute = '/monitor' } = {}) {
            const query = {
                fromIncomingCall: '1',
                openedAt: String(Date.now()),
            }

            if (roomId) query.callRoomId = roomId
            if (from) query.callFrom = from
            if (fromLabel) query.callFromLabel = fromLabel

            const resolvedRoute = targetRoute && typeof targetRoute === 'string' ? targetRoute : '/monitor'
            await this.$router.push({ path: resolvedRoute, query }).catch(() => null)
        },
        handleOperatorIncomingCall: function (payload = {}) {
            if (!this.isOperatorSessionActive()) return
            const incomingCall = this.normalizeIncomingCallPayload(payload)
            if (!incomingCall.roomId || !incomingCall.from) return

            const currentPending = peekPendingIncomingCall()
            if (String(currentPending?.roomId || '') === String(incomingCall.roomId)) {
                return
            }

            setPendingIncomingCall(incomingCall)

            const targetRoute = this.resolveIncomingCallTargetRoute(incomingCall)
            const currentRoute = this.$route?.path || ''

            // Se o operador já está na tela certa (monitor para shieldgo-app
            // ou alert-occurrence para alertport-app), a própria tela abre o modal
            // de chamada via seu próprio handler de socket/bridge.
            if (targetRoute === '/monitor' && (currentRoute === '/monitor' || currentRoute === '/monitor/surveillance')) return
            if (targetRoute === '/monitor/alert-occurrence' && currentRoute === '/monitor/alert-occurrence') return

            this.incomingCallNotificationRoomId = incomingCall.roomId
            this.startIncomingCallRingtone()
            this.showIncomingCallNotification(incomingCall)
        },
        handleOperatorCallFinished: function ({ roomId = '' } = {}) {
            if (!roomId) return
            clearPendingIncomingCall(roomId)
            if (String(this.incomingCallNotificationRoomId || '') !== String(roomId)) return
            this.incomingCallNotificationRoomId = ''
            this.stopIncomingCallRingtone()
        },
        registerOperatorOnSocket: function ({ force = false } = {}) {
            if (!this.isOperatorSessionActive()) return
            const identity = this.getOperatorSocketIdentity()
            if (!identity.userId || !identity.accountId) {
                return
            }
            if (!socket.connected) return

            const identityKey = `${identity.userId}|${identity.accountId}|${identity.role}|${identity.displayName}`
            if (!force && this.operatorSocketIdentityKey === identityKey) return

            socket.emit(
                'user:register',
                {
                    userId: identity.userId,
                    accountId: identity.accountId,
                    role: identity.role,
                    clientType: 'ADMIN_MONITOR',
                    displayName: identity.displayName,
                },
                ack => {
                    if (ack?.ok) {
                        this.operatorSocketIdentityKey = identityKey
                    } else if (ack?.error) {
                        // socket identity registration failed
                    }
                },
            )
        },
        bindOperatorSocketHandlers: function () {
            if (this.operatorSocketHandlers) return

            const onConnect = () => {
                this.registerOperatorOnSocket({ force: true })
            }
            const onDisconnect = () => {
                this.operatorSocketIdentityKey = ''
            }
            const onCallIncoming = payload => {
                this.handleOperatorIncomingCall(payload)
            }
            const onCallEnd = payload => {
                this.handleOperatorCallFinished(payload)
            }
            const onCallReject = payload => {
                this.handleOperatorCallFinished(payload)
            }

            this.operatorSocketHandlers = {
                onConnect,
                onDisconnect,
                onCallIncoming,
                onCallEnd,
                onCallReject,
            }

            socket.on('connect', onConnect)
            socket.on('disconnect', onDisconnect)
            socket.on('call:incoming', onCallIncoming)
            socket.on('call:end', onCallEnd)
            socket.on('call:reject', onCallReject)
        },
        unbindOperatorSocketHandlers: function () {
            if (!this.operatorSocketHandlers) return
            socket.off('connect', this.operatorSocketHandlers.onConnect)
            socket.off('disconnect', this.operatorSocketHandlers.onDisconnect)
            socket.off('call:incoming', this.operatorSocketHandlers.onCallIncoming)
            socket.off('call:end', this.operatorSocketHandlers.onCallEnd)
            socket.off('call:reject', this.operatorSocketHandlers.onCallReject)
            this.operatorSocketHandlers = null
        },
        syncOperatorSocketConnection: function () {
            if (!this.isOperatorSessionActive()) {
                this.operatorSocketIdentityKey = ''
                this.incomingCallNotificationRoomId = ''
                clearPendingIncomingCall()
                this.stopIncomingCallRingtone()
                this.unbindOperatorSocketHandlers()
                return
            }

            this.bindOperatorSocketHandlers()

            if (!socket.connected && typeof socket.connect === 'function') {
                socket.connect()
                return
            }

            this.registerOperatorOnSocket()
        },
        extractPatrolActionId: function (notificationData = {}) {
            const patrolAction = notificationData?.patrolAction
            if (typeof patrolAction === 'string') return patrolAction
            if (patrolAction && typeof patrolAction === 'object') {
                return patrolAction?._id || patrolAction?.id || ''
            }

            return notificationData?.patrolActionId || ''
        },
        getGlobalNotificationConfig: function (type) {
            const notificationMap = {
                SOS_ALERT: {
                    title: this.$t('msg.new.sos.notification'),
                    type: 'error',
                    shouldPlaySound: true,
                },
                INCIDENT: {
                    title: this.$t('msg.new.incident.notification'),
                    type: 'warn',
                    shouldPlaySound: false,
                },
                CANCEL_PATROL: {
                    title: this.$t('msg.new.canceled.patrol.notification'),
                    type: 'indigo',
                    shouldPlaySound: false,
                },
                TIME_ENTRY: {
                    title: 'Novo evento de presença (AlertPort)',
                    type: 'indigo',
                    shouldPlaySound: false,
                },
            }

            return notificationMap[type] || null
        },
        isAlertportNotification: function (notificationData = {}) {
            return String(notificationData?.source || '').toUpperCase() === 'ALERTPORT'
        },
        playSosAlertSound: function () {
            if (this.$session.get('sound') === false) return

            const audio = new Audio(alarmSoundUrl)
            audio.play().catch(() => {
            })
        },
        showGlobalNotification: function (notificationData = {}, siteId = '') {
            const notificationType = notificationData?.type
            const notificationConfig = this.getGlobalNotificationConfig(notificationType)
            if (!notificationConfig) return

            const user = this.$session.get('user')
            const timezone = Common.resolveTimezoneId(user?.accountTimezone || user?.account?.timezone || 'America/Sao_Paulo')
            const date = moment.tz(timezone).format('DD/MM/YYYY - HH:mm:ss')
            const patrolActionId = this.extractPatrolActionId(notificationData)
            const source = this.isAlertportNotification(notificationData) ? 'ALERTPORT' : 'SHIELDGO'
            const targetRoute = source === 'ALERTPORT' ? '/monitor/alert-occurrence' : '/monitor'

            if (notificationConfig.shouldPlaySound) {
                this.playSosAlertSound()
            }

            this.$notify({
                group: 'alerts-global',
                type: notificationConfig.type,
                title: notificationConfig.title,
                text: `${this.$t('str.date.subtitle')}: ${date}<br>${this.$t('msg.alert.notification.click.to.open.monitor')}`,
                duration: -1,
                data: {
                    patrolActionId,
                    notificationType,
                    siteId,
                    source,
                    targetRoute,
                },
            })
        },
        syncSosNotificationListeners: function () {
            const sites = this.getOperatorSites()
            const sitesKey = sites.join('|')
            if (sites.length === 0) {
                this.clearSosNotificationListeners()
                return
            }

            if (sitesKey === this.sosNotificationSitesKey && this.sosNotificationsUnsubscribes.length > 0) {
                return
            }

            this.clearSosNotificationListeners()
            this.sosNotificationSitesKey = sitesKey

            sites.forEach(siteId => {
                const notificationDocRef = doc(db, 'notifications', siteId)
                const unsubscribe = onSnapshot(notificationDocRef, async snapshot => {
                    if (!snapshot.exists()) return
                    const notificationData = snapshot.data()
                    if (!notificationData) return
                    if (!this.getGlobalNotificationConfig(notificationData?.type)) return

                    const isAlertport = this.isAlertportNotification(notificationData)
                    const currentRoute = this.$route?.path || ''
                    // Se o operador já está na tela responsável pela origem do evento,
                    // a própria tela cuidará do alerta e limpeza do documento.
                    if (isAlertport && currentRoute === '/monitor/alert-occurrence') return
                    if (!isAlertport && (currentRoute === '/monitor' || currentRoute === '/monitor/surveillance')) return

                    this.showGlobalNotification(notificationData, siteId)

                    try {
                        await deleteDoc(notificationDocRef)
                    } catch {
                        // ignore delete errors
                    }
                })

                this.sosNotificationsUnsubscribes.push(unsubscribe)
            })
        },
        navigateToMonitorFromAlert: async function ({ patrolActionId = '', notificationType = '', siteId = '', targetRoute = '/monitor' } = {}) {
            const query = {
                fromAlert: '1',
                openedAt: String(Date.now()),
            }

            if (patrolActionId) {
                query.patrolActionId = patrolActionId
            }
            if (notificationType) {
                query.notificationType = notificationType
            }
            if (siteId) {
                query.siteId = siteId
            }

            const resolvedRoute = targetRoute && typeof targetRoute === 'string' ? targetRoute : '/monitor'
            await this.$router.push({ path: resolvedRoute, query }).catch(() => null)
        },
        handleGlobalNotificationClick: async function (props) {
            const callRoomId = props?.item?.data?.callRoomId || ''
            if (callRoomId) {
                const callFrom = props?.item?.data?.callFrom || ''
                const callFromLabel = props?.item?.data?.callFromLabel || ''
                const callTargetRoute = props?.item?.data?.callTargetRoute || '/monitor'
                props?.close?.()
                this.stopIncomingCallRingtone()
                await this.navigateToMonitorFromIncomingCall({ roomId: callRoomId, from: callFrom, fromLabel: callFromLabel, targetRoute: callTargetRoute })
                return
            }

            const patrolActionId = props?.item?.data?.patrolActionId || ''
            const notificationType = props?.item?.data?.notificationType || ''
            const siteId = props?.item?.data?.siteId || ''
            const targetRoute = props?.item?.data?.targetRoute || '/monitor'
            props?.close?.()
            await this.navigateToMonitorFromAlert({ patrolActionId, notificationType, siteId, targetRoute })
        },
    },
    mounted() {
        this.$insProgress.finish()
        this.$i18n.locale = this.$session.get('user')?.language || 'pt'
        this.syncDarkModeFromSession()
        this.syncSosNotificationListeners()
        this.syncOperatorSocketConnection()
        this.operatorSocketHeartbeat = window.setInterval(() => {
            this.syncOperatorSocketConnection()
        }, 10000)
    },
    created() {
        AppOptions.appBodyScrollTop = window.scrollY

        window.addEventListener('scroll', this.handleScroll)

        this.$insProgress.start()
        this.handleSetColor()
        this.handleSetFont()
        this.syncDarkModeFromSession()

        this.$registerEvent.$on(
            'setDarkMode',
            function (value) {
                AppOptions.appDarkMode = value
                this.handleSetDarkMode(value)
            }.bind(this),
        )

        if (AppOptions.appTheme) {
            this.handleSetTheme(AppOptions.appTheme)
        }

        this.$router.beforeEach((to, from, next) => {
            this.$insProgress.start()
            this.handleSetDarkMode(AppOptions.appDarkMode === true)
            if (AppOptions.appTheme) {
                this.handleSetTheme(AppOptions.appTheme)
            }
            next()
        })
        this.$router.afterEach(() => {
            this.$insProgress.finish()
            AppOptions.appSidebarMobileToggled = false
            this.syncSosNotificationListeners()
            if (this.$route?.path === '/monitor') {
                this.stopIncomingCallRingtone()
            }
            this.syncOperatorSocketConnection()
        })
    },
    beforeDestroy() {
        this.clearSosNotificationListeners()
        if (this.operatorSocketHeartbeat) {
            clearInterval(this.operatorSocketHeartbeat)
            this.operatorSocketHeartbeat = null
        }
        this.stopIncomingCallRingtone()
        this.unbindOperatorSocketHandlers()
    },
}
</script>
